<template>
  <div>
    <div v-for="actionsSet in profileActions" class="tw-mt-4">
      <div class="tw-mb-10">
        <span class="tw-font-bold" v-text="actionsSet.filter.value"></span>
        <span class="tw-ml-6 tw-text-grey-dark">
          {{ `${actionsSet.total} ${$t('wi.swings')}` }}
        </span>
      </div>

      <div class="tw-flex tw-flex-wrap tw-justify-center lg:tw-justify-start">
        <div
          v-for="action in actionsSet.actions"
          :key="action.label"
          v-if="action.visible && parseFloat(action.average)"
          class="stat tw-w-full tw-mb-4 tw-mx-2 tw-h-32 stat-left"
          :class="{ highlight: action.highlighted }"
        >
          <i class="fas fa-star pull-right"></i>
          <span class="stat-name tw-mb-4" v-html="action.name"></span><br />
          <p class="tw-flex tw-flex-col" v-if="action.score_metric">
            <span
              class="small-stat tw-leading-none tw-mb-2"
              v-html="action.score"
            ></span>
            <progress-bar :progress="action.score"></progress-bar>
          </p>
          <p class="tw-flex tw-justify-between" v-else>
            <span
              class="small-stat tw-leading-none"
              v-html="action.average"
            ></span>
            <span
              class="text-muted stat-unit tw-inline-flex tw-items-end"
              v-html="actionUnit(action)"
            ></span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.stat {
  max-width: 14.4rem;
}
</style>

<script>
import { mapGetters } from 'vuex';
import ProgressBar from '../VisualElements/ProgressBar';

export default {
  name: 'BaseballMetrics',
  components: {
    ProgressBar
  },
  computed: {
    ...mapGetters({
      profileActions: 'player-profile/profileActions'
    }),
  },
  methods: {
    actionUnit(action) {
      const unit = action.unit;
      const ignoredUnits = ['°'];

      if (ignoredUnits.includes(unit)) {
        return '';
      }

      return unit;
    },
  },
};
</script>
